var render = function render(_c,_vm){return _c('pre',[_vm._v(_vm._s(_vm.props.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }